/**
* @file ListView.js

* @author - (Meera,Keerthana,Bhavithra)
* @sprint - B2W-Sprint-6
* @description - 
* This component displays data in a tabular format using Ant Design's Table component.
* It includes functionalities for  editing and deleting.
*/

import React from "react";
import { Space, Table, Tooltip, Popconfirm, Dropdown, Menu, Button, notification } from "antd";
import { EditOutlined, DeleteOutlined, MinusOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import moment from 'moment';
import { DATE_FORMAT,DDMMMYYYY_FORMAT } from "../../constants";


const { Column } = Table;

const AdminTrainingListView = ({ data, onDelete, onEdit }) => {
  console.log("Viewing:", data);
  /**
      * Handles editing a record.
     * @param {Object} record - The record to edit.
     */
  const handleEdit = (record) => {
    console.log("Editing:", record);
    onEdit(record);
  };

  /**
   * Handles deleting a record.
   * @param {Object} record - The record to delete.
   */
  const handleDelete = (record) => {

    console.log("Deleting___________:", record.id);
    onDelete(record);


  };

  return (
    <div>
      <div className="bg-white shadow-lg rounded-lg overflow-hidden">

        {/* Table Component */}
        <Table
          dataSource={Array.isArray(data) ? data : []}  // Ensure data is an array
          rowKey="key"
          className="w-full"
          scroll={{ x: true ,y:250}} // Enables horizontal scrolling if needed
          pagination={{ pageSize: 5 }}
          components={{
            header: {
              wrapper: (props) => (
                <thead {...props} className="bg-[var(--color-primary)] text-white" />
              ),
            },
          }}
          style={{ minHeight: '400px' }}  // Set minimum height
        >
          {/* Training Name Column */}
          <Column
            title="Training Name"
            dataIndex="trainingName"
            key="trainingName"
            width="550px"
            align="left" // Left align header text
          />

          {/* Description Column */}
          <Column
            title="Description"
            dataIndex="description"
            key="description"
            width="550px"
            align="left"
          />

         {/* Start Date Column */}
         <Column
            title="Start Date"
            dataIndex="trainingStartDate"
            key="trainingStartDate"
            width="300px"
            align="left" // Left align header text
            render={(text) => moment(text).format("DD MMM YYYY")}
          />
 
          {/* End Date Column */}
          <Column
            title="End Date"
            dataIndex="trainingEndDate"
            key="trainingEndDate"
            width="300px"
            align="left" // Left align header text
            // render={(text) => moment(text, DATE_FORMAT).format(DDMMMYYYY_FORMAT)}
            render={(text) => moment(text).format("DD MMM YYYY")}
          />
          {/* StartTime Column */}
          <Column
            title="Start Time"
            dataIndex="startTime"
            key="startTime"
            width="300px"
            align="left"
          />


          {/*End  Time Column */}
          <Column
            title="End Time"
            dataIndex="endTime"
            key="endTime"
            width="300px"
            align="left"
          />


          {/* POC Mail ID Column */}
          <Column
            title="POC Mail ID"
            dataIndex="emailId"
            key="emailId"
            width="550px"
            align="left"
          />

          {/* Pre-requisites Column */}
          <Column
            title="Pre-Requisites"
            dataIndex="prerequisites"
            key="prerequisites"
            width={550}
            align="left"
          />

          {/* Training Mode Column */}
          <Column
            title="Training Mode"
            dataIndex="trainingMode"
            key="trainingMode"
            width={550}
            align="left"
          />

          {/* Actions Column */}
          <Column
            title="Action"
            key="action"
            width={400}
            align="center"
            render={(_, record) => (
              <Space size="middle">

                {/* Edit Button */}
                <Tooltip title="Edit">
                  <button
                    onClick={() => handleEdit(record)}
                    className="p-2 text-green-500 transition hover:text-green-700"
                  >
                    <EditOutlined className="text-lg" />
                  </button>
                </Tooltip>
                {/* Delete Button with Confirmation */}
                <Tooltip title="Delete">
                  <Popconfirm
                    title="Are you sure you want to delete this record?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => handleDelete(record)}
                    onCancel={() =>
                      toast.warn("Delete action was cancelled.", {
                        position: "top-right",
                        autoClose: 3000,
                        style: { fontSize: "16px" },
                      })
                    }
                  >
                    <button className="p-2 text-red-500 transition hover:text-red-700">
                      <DeleteOutlined className="text-lg" />
                    </button>
                  </Popconfirm>
                </Tooltip>


              </Space>
            )}
          />
        </Table>
      </div>
    </div>
  );
};
export default AdminTrainingListView;